import { IndexedParticipation, Participation } from '@app/api';
import { useTranslation } from 'react-i18next';
import { useParticipantDisplayName } from './ParticipantUtils';

export const useParticipationDisplayName = (
  participation?: Participation,
  defaultEmpty: boolean = false,
) => {
  const name = useParticipantDisplayName(
    participation?.participant,
    defaultEmpty,
  );
  if (name) {
    return name;
  }
  if (defaultEmpty) {
    return '';
  }

  if (!participation) {
    return undefined;
  }

  return participation.trackingId;
};

export const useIndexedParticipationDisplayName = (
  participation: IndexedParticipation,
  defaultEmpty: boolean = false,
) => {
  const { t } = useTranslation();

  if ('deletedAt' in participation && participation.deletedAt) {
    return t('participants.deleted');
  }
  if ('fullName' in participation && participation?.fullname) {
    return participation.fullname;
  } else if (participation.firstname || participation.lastname) {
    if (participation.firstname && participation.lastname) {
      return `${participation.firstname} ${participation.lastname}`;
    }
    return participation.firstname || participation.lastname;
  } else if (!defaultEmpty) {
    return participation.email;
  } else {
    return '';
  }
};
